class Bus
{
    //监听事件
    on(eventname, cb, cbthis)
    {
        if( !this.listeners ) this.listeners = {};
        let evtListeners = this.listeners[eventname];
        if( !evtListeners ) {
            evtListeners = [];
            this.listeners[eventname] = evtListeners;
        }
        
        let existL =  evtListeners.filter(item=>item.cb == cb);
        if( existL && existL.length > 0  ) {
            existL[0].cbthis = cbthis;
            return;
        }

        evtListeners.push({cb,cbthis});
    }
    //取消监听
    off(eventname, cb)
    {
        if( !this.listeners ) return;

        let evtListeners = this.listeners[eventname];
        if( !evtListeners ) return;
        if( !cb ) {
            this.listeners[eventname] = [];
            return ;
        }

        let n = evtListeners.length;
        while( n-- ) {
            if( evtListeners[n].cb == cb){
                evtListeners.splice(n,1);
                break;
            }
        }
    }

    //触发事件
    emit(eventname, ...args)
    {
        if( !this.listeners ) return;
        let evtListeners = this.listeners[eventname];
        if( !evtListeners || evtListeners.length < 1) return;
        let copyed = evtListeners.slice(0);
        let n = copyed.length;
        
        for(let i=0;i<n;i++)
        {
            let item  = copyed[i];
            if( !item.cbthis ) item.cbthis = this;
            item.cb.call(item.cbthis, ...args);
        }
    }
}

window.Bus = new Bus();

let search = window.location.href.split("?")[1];
let ret = {};
if( search )
{
  let aParams = search.split('&')
  let len = aParams.length

  for (var i = 0; i < len; i++) {
    var aParam = aParams[i].split('=')
    var sParamName = decodeURIComponent(aParam[0])
    var sParamValue = decodeURIComponent(aParam[1])
    ret[sParamName] = sParamValue
  }
}
window.httpQuery = ret;
export default Bus;